import { useContext } from 'react';

import { Icon, Menu } from '@atom/mui';
import { ContentCopyIcon, DeleteIcon, EditIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { Budget, BudgetModal } from '@atom/types/budget';

import BudgetsContext from './BudgetsContext';

import classes from './budgets.module.css';

const { MenuItem } = Menu;

interface Props {
  budget: Budget;
  canEdit: boolean;
  canDuplicate: boolean;
  canDelete: boolean;
}

const BudgetsOptions = ({
  budget,
  canEdit,
  canDuplicate,
  canDelete,
}: Props) => {
  const { setActiveModal, setActiveFormBudget } = useContext(BudgetsContext);

  const handleOpenEdit = () => {
    setActiveModal(BudgetModal.EDIT);
    setActiveFormBudget(budget);
  };
  const handleOpenDuplicate = () => {
    setActiveModal(BudgetModal.DUPLICATE);
    setActiveFormBudget(budget);
  };
  const handleOpenDelete = () => {
    setActiveModal(BudgetModal.DELETE);
    setActiveFormBudget(budget);
  };

  return (
    <div
      className={classes.optionsWrapper}
      data-cy={`budgetOptionMenu-${budget?.name}`}
    >
      <Menu IconProps={{ color: colors.neutral.gray }}>
        {canEdit && (
          <MenuItem
            className={classes.menuItem}
            onClick={handleOpenEdit}
            data-cy="budgetEditOption"
          >
            <div className={classes.primaryTextBox}>
              <div className={classes.iconBox}>
                <Icon icon={EditIcon} />
                <div className={classes.primaryText}>Edit Budget</div>
              </div>
            </div>
          </MenuItem>
        )}
        {canDuplicate && (
          <MenuItem
            className={classes.menuItem}
            onClick={handleOpenDuplicate}
            data-cy="budgetDuplicateOption"
          >
            <div className={classes.primaryTextBox}>
              <div className={classes.iconBox}>
                <Icon icon={ContentCopyIcon} />
                <div className={classes.primaryText}>Duplicate Budget</div>
              </div>
            </div>
          </MenuItem>
        )}
        {canDelete && (
          <MenuItem
            className={classes.menuItem}
            onClick={handleOpenDelete}
            data-cy="budgetDeleteOption"
          >
            <div className={classes.primaryTextBox}>
              <div className={classes.iconBox}>
                <Icon color={colors.neutral.gray} icon={DeleteIcon} />
                <div className={classes.primaryText}>Delete</div>
              </div>
            </div>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default BudgetsOptions;
